import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import './MercurXModalLoadingOverlay.scss';

function MercurXModalLoadingOverlay({
  show,
  eyebrow,
  title,
  description,
  note,
  variant = 'default',
}) {
  if (!show) {
    return null;
  }

  return (
    <div
      className={`mercurx-modal-loading-overlay${
        variant === 'compact' ? ' mercurx-modal-loading-overlay--compact' : ''
      }`}
      aria-live="polite"
      aria-busy="true"
    >
      <div className="mercurx-modal-loading-card">
        <div className="mercurx-modal-loading-spinner-wrap">
          <Spinner animation="border" />
        </div>
        {eyebrow && <div className="mercurx-modal-loading-eyebrow">{eyebrow}</div>}
        {title && <div className="mercurx-modal-loading-title">{title}</div>}
        {description && <p className="mercurx-modal-loading-copy">{description}</p>}
        {note && <div className="mercurx-modal-loading-note">{note}</div>}
      </div>
    </div>
  );
}

export default MercurXModalLoadingOverlay;
